/** @jsx jsx */

import { Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import LinkButton from 'app/common/components/LinkButton';

import CTA from './CTA';

const CTAStart = () => (
  <CTA>
    <CTA.Header>Join an integration as collaborators</CTA.Header>
    <CTA.Body margin="15px 0px">
      <Text tag="p">
        Collaborators can log in to view performance data, user feedback, and
        access embed tools, but can’t make changes.
      </Text>
    </CTA.Body>
    <LinkButton variant="primary" href="/join-integration">
      Get access
    </LinkButton>
  </CTA>
);

export default CTAStart;
